import { ReduxService } from 'dashboard-services/services';

import { csvEditorActions } from 'actions/modules/tools';

export const csvEditorInitialState = {
  editable: false,
  id: undefined,
  newFile: false,
  open: false,
  groupName: undefined,
  provider: undefined
}

export default (state = csvEditorInitialState, action) => {

  switch (action.type) {
    case csvEditorActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}